import React from 'react'
import "./HomePartners.css";

const HomePartnerHead = () => {
  return (
    <div className='homePartnerHead-container'>
      <h2>Our <span>Partners</span></h2>
    </div>
  )
}

export default HomePartnerHead
